import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const EyeThickIcon = ({ color = 'black', size = 'md', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} viewBox="0 0 24 25" {...iconSizes[size]} fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M22 12C22 12 18.0751 19 12 19C5.92487 19 2 12 2 12C2 12 5.92487 5 12 5C18.0751 5 22 12 22 12Z"
        strokeWidth={2}
        stroke={color}
      />
      <circle
        cx="12"
        cy="12"
        r="3"
        strokeWidth={2}
        stroke={color}
      />
    </svg>

  );
};

export default EyeThickIcon;
